import contextAwareMenu from './js/menu';
import activeMenuItem from './js/menu-active';

import './js/header-toggles';
import './js/a11y-event-calendar-pro-fixes';
import './js/youtube-embed-pause-playback';
import './js/a11y-easy-notification-bar-fixes';

contextAwareMenu('.wp-custom-block-navigation-primary');
activeMenuItem();

console.info('NAH 1.8.38');